module.exports = __webpack_public_path__ + "static/Raleway-SemiBold-5a25c50b181b07279489ce5bb6a9545c.ttf";